import React from 'react';
import { Button, CircularProgress, Stack } from '@mui/material';
import { Subscription } from '@domain/subscription/models/SubscriptionPlan';
import { Icon } from '@shared/icons';
import { useSubscription } from '../../../hooks/useSubscription';
import { PlanHeader } from './PlanHeader';

interface StripeSubscriptionSectionProps {
  subscription: Subscription;
  onChangePlan: () => void;
}

export const StripeSubscriptionSection: React.FC<StripeSubscriptionSectionProps> = ({
  subscription,
  onChangePlan,
}) => {
  const { createPortalSession, isCreatingPortalSession } = useSubscription();

  const handleOpenBillingPortal = async () => {
    try {
      const result = await createPortalSession();
      if (result.url) {
        window.open(result.url, '_blank');
      }
    } catch (error) {
      console.error('Failed to create portal session:', error);
    }
  };

  return (
    <Stack spacing={2} direction="row" alignItems="center" justifyContent="space-between">
      <PlanHeader
        name={subscription.plan.name}
        status={subscription.status}
        description={subscription.plan.description}
      />

      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
        <Button
          variant="outlined"
          size="small"
          startIcon={<Icon icon="ArrowRefresh03" />}
          onClick={onChangePlan}
        >
          Change plan
        </Button>
        <Button
          variant="outlined"
          size="small"
          startIcon={
            isCreatingPortalSession
              ? <CircularProgress size={14} />
              : <Icon icon="LinkExternal" />
          }
          onClick={handleOpenBillingPortal}
          disabled={isCreatingPortalSession}
        >
          {isCreatingPortalSession ? 'Opening...' : 'Billing portal'}
        </Button>
      </Stack>
    </Stack>
  );
};
